var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-swipe',{staticClass:"topSwipe",attrs:{"autoplay":_vm.autoplayTime,"indicator-color":"white"}},_vm._l((_vm.imgs),function(item,index){return _c('van-swipe-item',{key:index,on:{"click":function($event){return _vm.clickImg(index)}}},[_c('img',{class:_vm.className,attrs:{"src":item,"alt":""}})])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }